/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Report export filename and timestamp formatting helpers.
 * @module utils/reportHelpers
 */

import dayjs from "dayjs";
import { REPORT_FILE_DATE_FORMAT, buildReportFilename } from "./reportConstants.js";

export const formatReportDateTime = () =>
  dayjs().format(REPORT_FILE_DATE_FORMAT);

export const sanitizeEventNameForFilename = (name) =>
  (name || "evento")
    .trim()
    .replace(/[/\\:*?"<>|]/g, "")
    .replace(/\s+/g, "-");

export const buildEventReportFilename = (prefix, eventName, extension = "xlsx") =>
  buildReportFilename(
    `${prefix}-${sanitizeEventNameForFilename(eventName)}`,
    formatReportDateTime(),
    extension,
  );

export const buildTimestampedReportFilename = (prefix, extension = "xlsx") =>
  buildReportFilename(prefix, formatReportDateTime(), extension);
